export default "__VITE_ASSET__Z67wWQXz__"